@if (showSection === 'tabSection') {
  <app-header
    class="disable-page"
    (found)="handleResults($event)"
  ></app-header>
}
<!-- provider survey notification -->


@if (isProviderPortalSurveyPending) {
  <div class="portal-servey-section-notify" >
    <div  class="container provider-portal-servey-notify-container">
      <h5 class="heading">We Value Your Feedback!</h5>
      <!-- <button class="close-servey-notify close-btn" type="button" (click)="doServeylatter()">X</button> -->
      <img class="close-servey-notify" src="assets/images/icon_close copy.svg"  title="close" (click)="doSurveylatter()"/>
      <div class="quick-survey-btn d-flex">
        <p>Could you spare a moment to take a quick survey? Your insights are incredibly valuable to us.</p>
        <button  (click)="navigateToSurveyForm()" class="take-servey-btn">Take a Survey</button>
      </div>
    </div>
  </div>
}
@if (sideBtnVisibility) {
  <div class="portal-survey-side-btn">
    <button class="survey-side-btn" (click)="navigateToSurveyForm()">Complete a Survey</button>
  </div>
}

<ngx-loading
  [show]="loading"
  [config]="{ backdropBorderRadius: '14px' }"
></ngx-loading>

<div id="main-wrapper" [ngClass]="{'main-background-updated': isProviderPortalSurveyPending, 'main-background': !isProviderPortalSurveyPending}" class="main-background topSpace main-container homePage  disable-page">
  <div class="main-container searchContainerTop containerTop" style="margin-top: 10px;">
    <app-search-results [resultGridList]="data"></app-search-results>
  </div>
  <div class="container-fluid" style="padding: 0; padding-bottom: 150px;">
    <div class="row main-wrapper">
      <div class="col-md-9 row">
        <div class="col-md-12 title">
          <h3>Quick Links</h3>
        </div>
        <a  (click)="template1()" class="col-md-4 cursor-pointer" target="_blank" rel="noopener noreferrer">
          <div class="card">
            <img src="assets/images/icons/quick-links/assigned-member.svg">
            <div class="link-text">View Assigned Members</div>
          </div>
        </a>
        <a href="#/providerportal/report" class="col-md-4 cursor-pointer">
          <div class="card">
            <img src="assets/images/icons/quick-links/eligiblity-report.svg">
            <div class="link-text">View Eligibility Report</div>
          </div>
        </a>
                <a tabindex="0" routerLink="/providerportal/pqv-dashboard" aria-label="navigate to pqv dashboard" role="link"
          class="col-md-4 cursor-pointer">
          <div class="card">
            <img src="assets/images/pqv-icon.png" alt="pqv dashboard">
            <div class="link-text">View Clinical Documentation</div>
          </div>
        </a>
        <a  (click)="template5()" class="col-md-4 cursor-pointer" target="_blank" rel="noopener noreferrer">
          <div class="card">
            <img src="assets/images/icons/quick-links/claims_by_member.svg">
            <div class="link-text">View Claims by Member</div>
          </div>
        </a>

        <a (click)="template4()" class="col-md-4 cursor-pointer" target="_blank" rel="noopener noreferrer">
          <div class="card">
            <img src="assets/images/icons/quick-links/prior-auth.svg">
            <div class="link-text">View Prior Auths</div>
          </div>
        </a>
        <a  (click)="template7()" class="col-md-4 cursor-pointer" target="_blank" rel="noopener noreferrer">
          <div class="card">
            <img src="assets/images/icons/quick-links/diagnostics.svg">
            <div class="link-text">View Diagnosis, Procedure codes and Prior Authorization Look up</div>
          </div>
        </a>
        <a (click)="template3()" class="col-md-4 cursor-pointer" target="_blank" rel="noopener noreferrer">
          <div class="card">
            <img src="assets/images/icons/quick-links/provider.svg">
            <div class="link-text">View Medical Providers</div>
          </div>
        </a>
        <a  (click)="template6()" class="col-md-4 cursor-pointer" target="_blank" rel="noopener noreferrer">
          <div class="card">
            <img src="assets/images/icons/quick-links/submit-refer.svg">
            <div class="link-text">Submit New Auth or Referral</div>
          </div>
        </a>
        <a href="#/providerportal/provider-dataUpdate" class="col-md-4 cursor-pointer">
          <div class="card">
            <img src="assets/images/icons/quick-links/provider-data-managment.svg">
            <div class="link-text">Provider Data Management</div>
          </div>
        </a>
        <a href="#/providerportal/provider-training" class="col-md-4 cursor-pointer">
          <div class="card">
            <img style="width: 80px;" src="assets/images/icons/quick-links/training.png">
            <div class="link-text">Provider Training and Attestation</div>
          </div>
        </a>
        <a href="#/providerportal/care-plan-document" class="col-md-4 cursor-pointer">
          <div class="card">
            <img src="assets/images/icons/quick-links/care_plan_document.svg">
            <div class="link-text">View Careplan Document</div>
          </div>
        </a>
        <a routerLink="/providerportal/documents"
          [queryParams]="{ documentCode: 'PROV_COMM_DOC' }" class="col-md-4 cursor-pointer">
          <div class="card">
            <img src="assets/images/Document-folder.svg">
            <div class="link-text">Provider Reference Documents</div>
          </div>
        </a>

        <a href="#/providerportal/claimsummary" class="col-md-4 cursor-pointer">
          <div class="card">
            <img src="assets/images/icons/quick-links/claims-provider.svg">
            <div class="link-text">View Claims by Provider</div>
          </div>
        </a>
      </div>

      <div class="col-md-3">
        <div class="row title mb-35">
          <h3 class="p-0">Broadcast</h3>
        </div>

        <div class="newsCard">
          <div class="card">
            <div class="row news-header" align ="start">
              <div class="col-md-6">
                {{ broadcast[0]?.messageName}}
              </div>
              <div class="col-md-6" align ="end">
                {{ broadcast[0]?.updatedTimestamp | date }}
              </div>
            </div>


            <div class="card-body">
              <p class="broadcastBody broadcast-news-dashboard" [innerHTML]="broadcast[0]?.message"></p>
            </div>
          </div>
        </div>


        <!-- <div class="alert notify alert-dismissible fade show" role="alert">
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          aria-label="Close"
          >
          <span (click)="brodcastClosed()">x</span>
        </button>
        <div class="content">
          <div class="notifyBellIcon pull-left"></div>
          <div class="pull-left broadMessage" *ngIf="broadcast.length > 0">
            <h5
              class="modal-title broadcastmsgname"
              style="width: 100%; overflow: hidden"
              >
              <b>{{ broadcast[0].messageName}}</b>
            </h5>
            <div class="broadcastdate">
              <div class="text-left">
                Posted: {{ broadcast[0].updatedTimestamp}}
              </div>
            </div>
            <div
              [style.height.px]="calculateDivHeight(paragraph)"
              class="broacastMsg"
              id="broacastMsg"
              >
              <span
                class="broadcastBody content"
                [innerHTML]="broadcast[0].message"
                #paragraph
              ></span>
              <button
                type="button"
                class="pull-right viewMoreBtn"
                [disabled]="buttonDisabled"
                (click)="showfullContent()"
                >
                More
              </button>
            </div>
          </div>
        </div>
        <div class="clearBoth"></div>
      </div> -->

    </div>
  </div>

  <!-- <div class="row">
  <div class="col-lg-12">
    <app-search-results [resultGridList]="data"></app-search-results>
    <div class="alert notify alert-dismissible fade show" role="alert">
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
        >
        <span (click)="brodcastClosed()">x</span>
      </button>
      <div class="content">
        <div class="notifyBellIcon pull-left"></div>
        <div class="pull-left broadMessage" *ngIf="broadcast.length > 0">
          <h5
            class="modal-title broadcastmsgname"
            style="width: 100%; overflow: hidden"
            >
            <b>{{ broadcast[0].messageName}}</b>
          </h5>
          <div class="broadcastdate">
            <div class="text-left">
              Posted: {{ broadcast[0].updatedTimestamp}}
            </div>
          </div>
          <div
            [style.height.px]="calculateDivHeight(paragraph)"
            class="broacastMsg"
            id="broacastMsg"
            >
            <span
              class="broadcastBody content"
              [innerHTML]="broadcast[0].message"
              #paragraph
            ></span>
            <button
              type="button"
              class="pull-right viewMoreBtn"
              [disabled]="buttonDisabled"
              (click)="showfullContent()"
              >
              More
            </button>
          </div>
        </div>
      </div>
      <div class="clearBoth"></div>
    </div>
  </div>
</div> -->
<!-- <div class="row homeTab">
<div class="col-lg-12" style="padding-left: 0">
  <div class="tab homeAccrordian searchViewBar">
    <ul
      class="nav nav-tabs cup-detail-header panelHeading"
      role="tablist"
      >
      <li role="presentation" class="active">
        <div class="labels">SEARCH & VIEW</div>
        <a
          href="#Section1"
          aria-controls="home"
          role="tab"
          data-toggle="tab"
          style="min-width: 6em"
        ></a>
      </li>
    </ul>
          <div [ngClass]="
          !brodcastCloseFlag
            ? 'tabsListheight'
            : 'tabsList1'
        "
      class="tabsList " *ngIf="userError && userError === 'false'">
      <div class="row">
        <div class="col-md-6">
          <a
            (click)="template1()"
            href="../CUPPortal/#/singlesignon"
            target="_new"
            class="assignedMembersBg"
            >View Assigned Members</a
            >
          </div>
          <div class="col-md-6">
            <a
              (click)="template6()"
              href="../CUPPortal/#/singlesignon"
              target="_new"
              class="submitNewAuth"
              >Submit New Auth or Referral</a
              >
            </div>
            <div class="col-md-6">
              <a
                class="cool-link viewClaimsBgProvider"
                routerLink="/providerportal/report"
                #rtl="routerLinkActive"
                routerLinkActive="active"
                >View Eligibility Report
              </a>
            </div>
            <div class="col-md-6">
              <a
                class="cool-link viewClaimsBgProvider"
                routerLink="/providerportal/provider-training"
                #rtl="routerLinkActive"
                routerLinkActive="active"
                >Provider Training and Attestation
              </a>
            </div>

            <div class="col-md-6">
              <a
                (click)="template5()"
                href="../CUPPortal/#/singlesignon"
                target="_new"
                class="viewClaimsBg"
                >View Claims by Member
              </a>
            </div>
            <div  class="col-md-6">
              <a
                class="cool-link viewClaimsBgProvider"
                routerLink="/providerportal/care-plan-document"
                #rtl="routerLinkActive"
                routerLinkActive="active"
                >View Careplan Document
              </a>
            </div>
            <div class="col-md-6">
              <a
                class="cool-link viewClaimsBgProvider"
                routerLink="/providerportal/claimsummary"
                #rtl="routerLinkActive"
                routerLinkActive="active"
                >View Claims by Provider
              </a>
            </div>
            <div class="col-md-6">

            </div>
            <div class="col-md-6">
              <a
                (click)="template4()"
                href="../CUPPortal/#/singlesignon"
                target="_new"
                class="viewPriorAuthBg"
                >View Prior Auths</a
                >
              </div>
              <div class="col-md-6">

              </div>
              <div class="col-md-6">
                <a
                  (click)="template7()"
                  href="../CUPPortal/#/singlesignon"
                  target="_new"
                  class="viewDiagnosis"
                  >View Diagnosis and Procedure Codes</a
                  >
                </div>
                <div class="col-md-6">

                </div>
                <div class='col-md-6'>
                  <a
                    (click)="template3()"
                    href="../CUPPortal/#/singlesignon"
                    target="_new"
                    class="viewMedical"
                    >View Medical Providers</a
                    >
                  </div>
                  <div class="col-md-6">

                  </div>
                </div>
              </div>
            </div>
            <p-accordion id="accord" *ngIf="userError && userError === 'true'">
              <p-accordionTab>
                <p-header
                  ><a class="assignedMembersBg">View Assigned Members</a></p-header
                  >
                  <div class="accordion-info">
                    <p class="paraText">{{ userNoSitesInfo }}</p>
                  </div>
                </p-accordionTab>
                <p-accordionTab>
                  <p-header
                    ><a class="viewClaimsBg">View Claims by Member </a></p-header
                    >
                    <div class="accordion-info">
                      <p class="paraText">{{ userNoSitesInfo }}</p>
                    </div>
                  </p-accordionTab>
                  <p-accordionTab>
                    <p-header
                      ><a class="viewClaimsBgProvider"
                      >View Claims by Provider</a
                      ></p-header
                      >
                      <div class="accordion-info">
                        <p class="paraText">{{ userNoSitesInfo }}</p>
                      </div>
                    </p-accordionTab>
                    <p-accordionTab>
                      <p-header><a class="viewPriorAuthBg">View Prior Auths</a></p-header>
                      <div class="accordion-info">
                        <p class="paraText">{{ userNoSitesInfo }}</p>
                      </div>
                    </p-accordionTab>
                    <p-accordionTab>
                      <p-header
                        ><a class="submitNewAuth"
                        >Submit New Auth or Referral</a
                        ></p-header
                        >
                        <div class="accordion-info">
                          <p class="paraText">{{ userNoSitesInfo }}</p>
                        </div>
                      </p-accordionTab>
                      <p-accordionTab>
                        <p-header
                          ><a class="viewDiagnosis"
                          >View Diagnosis and Procedure Codes</a
                          ></p-header
                          >
                          <div class="accordion-info">
                            <p class="paraText">{{ userNoSitesInfo }}</p>
                          </div>
                        </p-accordionTab>
                        <p-accordionTab>
                          <p-header
                            ><a class="viewMedical">View Medical Providers</a></p-header
                            >
                            <div class="accordion-info">
                              <p class="paraText">{{ userNoSitesInfo }}</p>
                            </div>
                          </p-accordionTab>
                        </p-accordion>
                      </div>
                    </div> -->
                  </div>
                </div>
                <br><br>
                <app-footer></app-footer>
                <div
                  class="modal fade"
                  id="setQuestionsModal"
                  data-keyboard="false"
                  style="opacity: 1"
                  role="dialog"
                  >
                  <div class="modal-dialog modal-xl" style="margin-top: 200px">
                    <div class="modal-content">
                      <div
                        class="modal-header"
        style="
          border-bottom: 0px;
          font-family: Myriad Pro;
          flex-direction: column;
        "
                        >
                        <p>
                          <b style="font-size: 24px">
                            Add security questions to your account
                          </b>
                        </p>
                        <p style="font-size: 12px">
                          Please choose two security questions from below and provide answers.
                          These questions are required and will be used to recover your password
                          if you forget or lose it. These answers are confidential and will not
                          be used for any otheruser purpose.
                        </p>
                      </div>
                      <form data-toggle="validator" role="form">
                        <div>
                          <div class="modal-body text-center securityForm">
                            <div
              [ngClass]="
                isQuestion1Valid
                  ? 'wrap-input100 validate-input'
                  : 'wrap-input100 validate-input alert-validate'
              "
                              data-validate="Add security question"
                              class="form-group"
                              >
                              <select
                                required="true"
                                [ngModelOptions]="{ standalone: true }"
                                [(ngModel)]="que1"
                style="
                  font-size: 1.5rem;
                  height: calc(2.25rem + 12px);
                  font-family: Myriad Pro;
                "
                                class="form-control"
                                ng-options="let option of questions1"
                                >
                                <option value="" hidden style="display: none"></option>
                                @for (option of questions1; track option) {
                                  <option
                                    [value]="option.securityQuestion"
                                    >
                                    {{ option.securityQuestion }}
                                  </option>
                                }
                              </select>
                            </div>
                            <div
              [ngClass]="
                isAns1Valid
                  ? 'wrap-input100 validate-input'
                  : 'wrap-input100 validate-input alert-validate'
              "
                              data-validate="Add security answer"
                              class="form-group"
                              style="font-family: Myriad Pro"
                              >
                              <input
                                [ngModelOptions]="{ standalone: true }"
                                required="required"
                                type="text"
                                placeholder="Answer"
                                [(ngModel)]="ans1"
                                style="font-size: 1.5rem"
                                class="form-control"
                                />
                              </div>
                              <div
              [ngClass]="
                isQuestion2Valid
                  ? 'wrap-input100 validate-input'
                  : 'wrap-input100 validate-input alert-validate'
              "
                                data-validate="Add security question"
                                class="form-group"
                                >
                                <select
                                  [ngModelOptions]="{ standalone: true }"
                                  [(ngModel)]="que2"
                style="
                  font-size: 1.5rem;
                  height: calc(2.25rem + 12px);
                  font-family: Myriad Pro;
                "
                                  class="form-control"
                                  >
                                  <option value="" hidden style="display: none"></option>
                                  @for (option of questions2; track option) {
                                    <option
                                      [value]="option.securityQuestion"
                                      >
                                      {{ option.securityQuestion }}
                                    </option>
                                  }
                                </select>
                              </div>
                              <div
              [ngClass]="
                isAns2Valid
                  ? 'wrap-input100 validate-input'
                  : 'wrap-input100 validate-input alert-validate'
              "
                                data-validate="Add security answer"
                                class="form-group"
                                style="font-family: Myriad Pro"
                                >
                                <input
                                  [ngModelOptions]="{ standalone: true }"
                                  type="text"
                                  placeholder="Answer"
                                  [(ngModel)]="ans2"
                                  style="font-size: 1.5rem"
                                  class="form-control"
                                  />
                                </div>
                                <div class="text-center">
                                  <button
                                    type="button"
                                    class="btn btn-link"
                                    style="font-size: 15px; font-family: Myriad Pro; color: #23499E"
                                    (click)="getNextNotification()"
                                    >
                                    Update Later
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-primary"
                style="
                  background-color: #23499E;
                  border-color: #23499E;
                  font-size: 15px;
                  font-family: Myriad Pro;
                "
                                    (click)="updateQuestion()"
                                    >
                                    Update
                                  </button>
                                </div>
                                @if (failureMessage) {
                                  <div class="col-md-12 row">
                                    <p class="mailSentFailureMessage">{{ failureMessage }}</p>
                                  </div>
                                }
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="modal fade " style="z-index: 1500;"  tabindex="-1" id="trainingModalWarning" aria-hidden="true"  style="opacity: 1">
                    <div class="modal-dialog" style="margin-top: 15%">
                      <div class="modal-content">
                        <div class="modal-header" style="background-color:#23499E;color: white;">
                          Reminder

                        </div>
                        <div class="modal-body"> -->
                          <!-- <p>Please complete all Mandatory trainings within {{diffDays}} business days </p> -->
                          <!-- <p>You have {{diffDays}} days to complete the mandatory Annual Compliance Training.</p>
                          <br>
                            <p> {{headerMsg}}</p>
                            <br>
                              <p [innerHTML]="msgName"></p>
                              <br>
                              </div>
                              <div class="modal-footer">
                                <div class="container-contact100-form-btn">
                                  <button type="button" class="btn carelon-btn buttonInfo" data-bs-dismiss="modal">OK</button>
                                  <button type="button" (click)="navigateTotrainingNew()" class="btn carelon-btn buttonInfo" data-bs-dismiss="modal">
                                    Proceed to Training and Attestation
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> -->

                        <div class="modal fade" id="trainingModalWarning" style="z-index: 1052;"  tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                          <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                              <div class="modal-header d-flex justify-content-center">

                                <h6 class="text-center m-0"> Reminder</h6>
                                <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
                              </div>


                              <div class="modal-body">
                                <!-- <p>Please complete all Mandatory trainings within {{diffDays}} business days </p> -->
                                <p>You have {{diffDays}} days to complete the mandatory Annual Compliance Training.</p>
                                <p> {{headerMsg}}</p>
                                <p [innerHTML]="msgName"></p>
                              </div>
                              <div class="modal-footer">
                                <div class="container-contact100-form-btn">
                                  <button type="button" class="carelon-btn-ok buttonInfo me-3" data-bs-dismiss="modal">OK</button>
                                  <button type="button" (click)="navigateTotrainingNew()" class="proceedToTraningBtn buttonInfo" data-bs-dismiss="modal">
                                    Proceed to Training and Attestation
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="modal fade" id="warningAlearts" style="z-index: 1052;"  tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                          <div class="modal-dialog modal-lg modal-dialog-centered">
                            <div class="modal-content">
                              <div class="modal-header d-flex justify-content-center">

                                <h6 class="text-center m-0"> Reminder</h6>
                                <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
                              </div>


                              <div class="modal-body">
                                <!-- <p>Please complete all Mandatory trainings within {{diffDays}} business days </p> -->

                                <h4> {{warningsMsgs[currentIndex]?.messageName}}</h4>
                                <p [innerHTML]="warningsMsgs[currentIndex]?.message"></p>
                              </div>
                              <div class="modal-footer  d-flex justify-content-center">
                                <button type="button" class="carelon-btn-ok buttonInfo me-3" (click)="nextWarningMsg('warningAlearts')">OK</button>


                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="modal fade" data-keyboard = "false" data-backdrop = "static" id="trainingModal" role="dialog" style="opacity: 1">
                          <div class="modal-dialog" style="margin-top: 15%">
                            <div class="modal-content">
                              <div class="modal-header d-flex justify-content-center" style="background-color:#23499E;color: white;">
                                <h6 class="text-center m-0"> Reminder</h6>
                              </div>
                              <div class="modal-body">
                                <p>Please complete all the mandatory Annual Compliance Trainings.</p>
                              </div>
                              <div class="modal-footer d-flex justify-content-center ">
                                <div class="container-contact100-form-btn">
                                  <button
                                    type="button"
                                    (click)="navigateTotraining()"
                                    class="proceedToTraningBtn buttonInfo"
                                    data-bs-dismiss="modal"
                                    >
                                    Proceed to Training and Attestation
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="modal fade memberModal" id="viewMemberClaimsModal" role="dialog">
                          <div class="modal-dialog" style="margin-top: 15%">
                            <div class="modal-content">
                              <div class="modal-header">
                                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                              </div>
                              <div class="modal-body">
                                <p class="text-center margin0">
                                  Please select a member in the following screen to View Member Claims
                                </p>
                              </div>
                              <div class="modal-footer" style="justify-content: center">
                                <div class="container-contact100-form-btn">
                                  <button
                                    type="button"
                                    class="btn btn-primary buttonInfo"
                                    (click)="modalClose('viewMemberClaimsModal')"
                                    data-bs-dismiss="modal"
                                    >
                                    OK
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="modal fade memberModal" id="submitMemberAuthModal" role="dialog">
                          <div class="modal-dialog" style="margin-top: 15%">
                            <div class="modal-content">
                              <div class="modal-header">
                                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                              </div>
                              <div class="modal-body">
                                <p class="text-center margin0">
                                  Please select a member in the following screen to Submit New Auth or
                                  Referral
                                </p>
                              </div>
                              <div class="modal-footer" style="justify-content: center">
                                <div class="container-contact100-form-btn">
                                  <button
                                    type="button"
                                    class="btn btn-primary buttonInfo"
                                    (click)="modalClose('submitMemberAuthModal')"
                                    data-bs-dismiss="modal"
                                    >
                                    OK
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="modal fade" id="errorModal" role="dialog">
                          <div class="modal-dialog" style="margin-top: 15%">
                            <div class="modal-content">
                              <div class="modal-header">
                                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                              </div>
                              <div class="modal-body">
                                <p>{{ message }}</p>
                              </div>
                              <div class="modal-footer">
                                <div class="container-contact100-form-btn">
                                  <button
                                    type="button"
                                    class="btn btn-primary buttonInfo"
                                    data-bs-dismiss="modal"
                                    >
                                    Close
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="modal fade"
                          id="showBroadcastModal"
                          data-keyboard="false"
                          style="opacity: 1"
                          role="dialog"
                          >
                          <div class="modal-dialog modal-xl" style="margin-top: 200px">
                            @if (broadcast.length > 0) {
                              <div class="modal-content">
                                <div class="modal-header" style="flex-direction: column">
                                  <div class="row px-1 mx-3">
                                    <h5
                                      class="modal-title broadcastmsgname"
                                      style="width: 100%; overflow: hidden"
                                      >
                                      <b>{{ broadcast[0].messageName }}</b>
                                    </h5>
                                  </div>
                                  <div style="width: 100%; display: flex; justify-content: space-between">
                                    <div class="broadcastdate">
                                      <div class="text-left">
                                        Posted: {{ broadcast[0].updatedTimestamp }}
                                      </div>
                                    </div>
                                    <div>
                                      <div class="text-right broadcastdont">
                                        <a
                                          data-bs-dismiss="modal"
                                          href="#"
                                          (click)="disableBroadCast(broadcast[0].messageNo)"
                                          >Do not show again</a
                                          >
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="modal-body">
                                    <p class="broadcastBody" [innerHTML]="broadcast[0].message"></p>
                                  </div>
                                  <div class="modal-footer">
                                    <button
                                      type="button"
                                      class="btn btn-primary"
          style="
            background-color: #23499E;
            border-color: #23499E;
            font-size: 15px;
            font-family: Myriad Pro;
          "
                                      (click)="getNextNotification()"
                                      data-bs-dismiss="modal"
                                      >
                                      Close
                                    </button>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>

                          <div
                            class="modal fade"
                            id="changePasswordModal"
                            data-keyboard="false"
                            style="opacity: 1"
                            role="dialog"
                            >
                            <div class="modal-dialog modal-xl" style="margin-top: 100px">
                              <div class="modal-content"  style="width: 110%;">
                                <div class="modal-header">
                                  <h5 class="modal-title broadcastmsgname">
                                    <b>Please update your password</b>
                                  </h5>
                                </div>
                                <div class="modal-body row col-12">
                                  <div class="col-md-8">
                                    <div class="col-md-12">
                                      <input1-component
                                        [model]="inputComps.get('oldPassword')"
                                      ></input1-component>
                                    </div>
                                    <div class="col-md-12">
                                      <input1-component
                                        [model]="inputComps.get('newPassword')"
                                        minlenght="8"
                                        maxlength="15"
                                      ></input1-component>
                                    </div>
                                    <div class="col-md-12">
                                      <input1-component
                                        [model]="inputComps.get('confirmPassword')"
                                        minlenght="8"
                                        maxlength="15"
                                      ></input1-component>
                                    </div>
                                  </div>
                                  <div class="col-md-4 noteMessage">
                                    <b>Password Requirements:</b>
                                    <ul class="p-0" >
                                      <li style="list-style-type: disc !important;">  Password length must be between 8 and 15 characters.</li>
                                      <li style="list-style-type: disc !important;">  You cannot reuse any of your last 10 passwords. </li>
                                      <li style="list-style-type: disc !important;"> Passwords are case-sensitive and must include at least one lowercase letter (a-z), one uppercase letter (A-Z),  one number (0-9) and one special character ($, !, &#64;, *, ?, |). </li>
                                      <li style="list-style-type: disc !important;">  Blank spaces, the username as the password, and repeating characters or numbers more than twice in a row are not allowed.</li>

                                    </ul>
                                  </div>
                                  <br />
                                  <br />
                                  <div class="button-action pwd-footer">
                                    <div>
                                      @if (failureMessage) {
                                        <p class="mailSentFailureMessage">
                                          {{ failureMessage }}
                                        </p>
                                      }
                                    </div>
                                    <div class="passwordBtn">
                                      @if (isCredChangeOptional === true) {
                                        <button
                                          type="button"
                                          class="btn btn-link"
                                          style="font-size: 15px; font-family: Myriad Pro; color: #23499E"
                                          data-bs-dismiss="modal"
                                          (click)="getNextNotification()"
                                          >
                                          Update Later
                                        </button>
                                      }
                                      <button
                                        type="button"
                                        class="btn btn-primary"
              style="
                background-color: #23499E;
                border-color: #23499E;
                font-size: 15px;
                font-family: Myriad Pro;
              "
                                        (click)="changePassword()"
                                        >
                                        Update
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="modal fade" id="myModal" role="dialog" style="opacity: 1">
                            <div class="modal-dialog" style="margin-top: 15%">
                              <div class="modal-content">
                                <div class="modal-header"></div>
                                <div class="modal-body">
                                  <p>{{ errorMessage }}</p>
                                </div>
                                <div class="modal-footer">
                                  <div class="container-contact100-form-btn">
                                    <button
                                      type="button"
                                      (click)="myModalEventCallBack()"
                                      class="btn btn-primary"
            style="
              background-color: #23499E;
              border-color: #23499E;
              font-size: 15px;
              font-family: Myriad Pro;
            "
                                      data-bs-dismiss="modal"
                                      >
                                      Close
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="modal fade" id="noSiteModal" role="dialog" style="opacity: 1">
                            <div class="modal-dialog" style="margin-top: 15%">
                              <div class="modal-content">
                                <div class="modal-body">
                                  <p>{{ userNoSitesInfo }}</p>
                                </div>
                                <div class="modal-footer" style="justify-content: center !important">
                                  <div class="container-contact100-form-btn" >
                                    <button
                                      type="button"

                                      class="btn btn-primary carelon-btn"
            style="
              background-color: #23499E;
              border-color: #23499E;
              font-size: 15px;
              font-family: Myriad Pro;
            "
                                      data-bs-dismiss="modal"
                                      >
                                      ok
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>


                          <div class="modal fade" id="signInModal" role="dialog" style="opacity: 1">
                            <div class="modal-dialog" style="margin-top: 15%">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <button
                                    type="button"
                                    (click)="closeModal()"
                                    class="btn-close"
                                    data-bs-dismiss="modal"
                                  ></button>
                                </div>
                                <div class="modal-body">
                                  <div class="row">
                                    <div class="col-md-3 col-xs-12"></div>
                                    <div class="col-md-6 col-xs-12">
                                      <p>Authentication is required</p>
                                    </div>
                                    <div class="col-md-6 col-xs-12"></div>
                                  </div>
                                  <br />
                                  <br />
                                  <div class="row">
                                    <div class="col-md-3 col-xs-12"></div>
                                    <div class="col-md-6 col-xs-12">
                                      <form>
                                        <div
                [ngClass]="
                  isValidCred
                    ? 'wrap-input100 validate-input mb-0'
                    : 'wrap-input100 validate-input mb-0 alert-validate'
                "
                                          data-validate="Enter password"
                                          >
                                          <span class="btn-show-pass">
                                            <i
                                              [ngClass]="showCred ? 'zmdi zmdi-eye-off' : 'zmdi zmdi-eye'"
                                              (click)="togglePasswordShow($event)"
                                            ></i>
                                          </span>
                                          <input
                                            [attr.type]="showCred ? 'password' : 'text'"
                                            (focus)="onInputFocus($event)"
                                            (keypress)="passRestrict($event)"
                                            [(ngModel)]="UserCred"
                                            id="password"
                                            name="cred"
                                            type="password"
                  [ngClass]="
                    UserCred === '' ? 'input100' : 'input100 has-val'
                  "
                                            required
                                            />
                                            <span class="focus-input120" data-placeholder="Password"></span>
                                          </div>
                                        </form>
                                      </div>
                                      <div class="col-md-3 col-xs-12"></div>
                                    </div>
                                  </div>
                                  <div class="modal-footer">
                                    <div class="container-contact100-form-btn" style="float: right">
                                      <button
                                        type="button"
                                        (click)="validatePassword()"
                                        class="btn btn-primary buttonInfo"
                                        >
                                        Update
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="modal fade" id="alertModal" role="dialog" style="opacity: 1">
                              <div class="modal-dialog" style="margin-top: 15%">
                                <div class="modal-content">
                                  <div class="modal-header">
                                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                                  </div>
                                  <div class="modal-body">
                                    <p>
                                      {{ message }}
                                      <a (click)="closeModal()" routerLink="/providerportal/connect">
                                        here to report</a
                                        >
                                      </p>
                                    </div>
                                    <div class="modal-footer">
                                      <div class="container-contact100-form-btn">
                                        <button
                                          type="button"
                                          class="btn btn-primary buttonInfo"
                                          data-bs-dismiss="modal"
                                          >
                                          Close
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="modal fade" id="tokenExpiryModal" data-bs-keyboard="false"  role="dialog" style="opacity: 1">
                                <div class="modal-dialog" style="margin-top: 15%">
                                  <div class="modal-content alertPopup">
                                    <div class="modal-header">
                                      <!-- <div class="row">
                                      <div class="col-md-9">

                                      </div>
                                      <div class="col-md-3">
                                        <button type="button" class="close"
                                          data-dismiss="modal"><img src="../../../assets/images/Close.svg"
                                        alt="close"></button>
                                      </div>
                                    </div> -->
                                  </div>
                                  <div class="modal-body">
                                    <p class="text" style="text-align: center;">Session Expired. Please login again..</p>

                                  </div>
                                  <div class="modal-footer">
                                    <div class="col-md-12 pl-0 d-flex justify-content-center">
                                      <button type="button" data-bs-dismiss="modal" (click)="closeTokenExpiryPopup()"
                                      class="carelon-btn-ok">Close</button>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>

                            <!--Provider portal Survey form Modal -->
                            <div class="modal fade provider-survey-modal" id="providerSurveyModal">
                              <div class="modal-dialog modal-lg">
                                <div class="modal-content" >
                                  <ngx-loading [show]="showSpinner" [config]="{ backdropBorderRadius: '14px' }"></ngx-loading>
                                  <div class="modal-header" >
                                    <div class="row">
                                      <div class="col-md-4"></div>
                                      <div class="col-md-5">
                                        <h4 class="modal-title satisfaction-heading" id="exampleModalLabel">Provider Satisfaction Survey</h4>
                                      </div>
                                      <div class="col-md-3 text-end">
                                        <button type="button" class="btn-close me-2" data-bs-dismiss="modal" (click)="closeSurveyPopup()" aria-label="Close"></button>
                                      </div>
                                    </div>


                                  </div>
                                  <div class="modal-body">
                                    @if (surveyForm) {
                                      <form [formGroup]="surveyForm" (ngSubmit)="submitProviderSurvey()">
                                        <div class="surveyInfo">
                                          <h5>We Value Your Feedback!</h5>
                                          <p>CareMore Health APC is striving to improve the service we provide our physicians in the areas of Claims and the Utilization Management Program. Your feedback is invaluable to us, and we invite you to complete the following survey by April 30, 2025.</p>
                                        </div>
                                        <div class="row question-section d-block">
                                          <div
                                            class="form-group col-md-6 col-xs-12 cup-dd-down-arrow cup-dd-down-arrow-search cup-dd-down-screen-basis">
                                            <!-- [ngClass]="{'invalid': eligRequestErrorHealthPlan}" -->
                                            <label for="memberHealthPlan" class="labelsForHedisReport"><span class="required">*</span>SITE</label>
                                            <cup-autocomplete
                                              class="input-underline"
                                              [colWidth]="16"
                                              [(ngModel)]="selectedSite"
                                              [autoCompleteModel]="selectedSite"
                                              [autoCompleteDynamic]="true"
                                              [autoCompleteOptions]="sites"
                                              (autoCompleteModelChange)="setProviders($event)"
                                              emptyMessage='No Sites Found'
                                              [autoCompletePlaceholder]="'Select Site'"
                                            formControlName="siteUid"></cup-autocomplete>
                                          </div>
                                          <div class=" form-group col-md-6 col-xs-12 cup-dd-down-arrow cup-dd-down-screen-basis mutliSelectDropdown">
                                            <label for="memberHealthPlan" class="labelsForHedisReport"><span class="text-danger">*</span>PHYSICIANS</label>
                                            <angular2-multiselect
                                              [data]="providerList"
                                              [(ngModel)]="selectedProduct"
                                              class="multiselect-dropdown-style angularDropdown"
                                              [settings]="settings"
                                              formControlName="providerName"
                                              (onSelect)="onItemSelect($event)"
                                              (onDeSelect)="OnItemDeSelect($event)"
                                              (onDeSelectAll)="onDeSelectAll($event)"
                                              >
                                            </angular2-multiselect>
                                            @if (isSurveySubmitted) {
                                              <p class="text-danger" style="font-size: 14px;"> This provider has already submitted the survey. Please choose another provider! </p>
                                            }
                                          </div>
                                        </div>
                                        <!-- <div class="question-section">
                                        <p><span class="text-danger">*</span>Provider Type</p>
                                        <label class="dashBord-checkbox yes-checkBox">
                                          PCP
                                          <input type="radio"   name="isPCP" formControlName="isPCP" [value]="true"  [(ngModel)]="isPCP" disabled>
                                          <span class="checkmark"></span>
                                        </label>
                                        <label class="dashBord-checkbox yes-checkBox">
                                          SPC
                                          <input type="radio"   name="isPCP" formControlName="isPCP"[value]="false"  [(ngModel)]="isPCP" disabled>
                                          <span class="checkmark"></span>
                                        </label>
                                      </div> -->
                                      @for (question of providerSurveyQuestions ; track question; let questionIndex = $index) {
                                        <div class="question-section ">
                                          <p><span class="text-danger">*</span>{{question.description}}</p>
                                          @for (rating of providerSurveyRatings; track rating; let ratingIndex = $index) {
                                            <label class="dashBord-checkbox yes-checkBox">
                                              {{rating.description}}
                                              <input type="radio"   [name]="question.typeUid" [formControlName]="question.typeUid" [value]="rating.ratingValue">
                                              <span class="checkmark"></span>
                                            </label>
                                          }
                                        </div>
                                      }
                                      <div class="textArea pt-4">
                                        <p><span>Comments (Optional)</span></p>
                                        <textarea name="text"  formControlName="comment"   placeholder="Please, share any additional comments or suggestions here . . ."  id="textarea" ></textarea>
                                      </div>
                                      <div class="d-flex justify-content-center">
                                        <button type="submit" [disabled]="!surveyForm.valid || isSurveySubmitted" [ngClass]="{'disabledSurveySubmitBtn': !surveyForm.valid || isSurveySubmitted}" class="submit-responceBtn">Submit Your Response</button>
                                      </div>
                                    </form>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>


                          <!-- Survey success notication modal -->
                          <div class="modal" id="surveySuccessMsg">
                            <div class="modal-dialog modal-dialog-centered">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div class="modal-body">
                                  <div class="check-circle-icon">
                                    <i class="bi bi-check-circle">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                        <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
                                      </svg>
                                    </i>
                                  </div>
                                  <div class="modal-body-content">
                                    <div class="d-flex justify-content-center">
                                      <h2 style="color: #23499E;">Thank you!</h2>
                                    </div>
                                    <div class="d-flex justify-content-center">
                                      <p>Your responses  have been submitted successfully!</p>
                                    </div>
                                  </div>
                                </div>
                                <div class="modal-footer d-flex justify-content-center">
                                  <button type="button" class="closeBtn" (click)="closeModalAlert('surveySuccessMsg')" data-bs-dismiss="modal">Close</button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- CUP JWT error notication modal -->
                          <div class="modal" id="CupJwtErrMsg">
                            <div class="modal-dialog modal-dialog-centered ">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div class="modal-body">
                                  <div class="check-circle-err-icon" style="text-align:center">
                                    <i style="color: #23499E;" class="bi bi-exclamation-circle">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="currentColor" class="bi bi-exclamation-circle"
                                        viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                        <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
                                      </svg>
                                    </i>
                                  </div>
                                  <div class="modal-body-content">
                                    <div class="d-flex justify-content-center">
                                      <h3 style="color: #23499E;">Session Expired</h3>
                                    </div>
                                    <div class="d-flex justify-content-center text-center">

                                    </div>
                                  </div>
                                </div>
                                <div class="modal-footer d-flex justify-content-center">
                                  <button type="button" class="btn closeBtn" (click)="onCloseSessionOut('CupJwtErrMsg')" data-bs-dismiss="modal">Close</button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Survey error notication modal -->
                          <div class="modal" id="surveyErrorMsg">
                            <div class="modal-dialog modal-dialog-centered ">
                              <div class="modal-content">
                                <div class="modal-header">
                                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div class="modal-body">
                                  <div class="check-circle-err-icon">
                                    <i class="bi bi-exclamation-circle">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" fill="currentColor" class="bi bi-exclamation-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                        <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
                                      </svg>
                                    </i>
                                  </div>
                                  <div class="modal-body-content">
                                    <div class="d-flex justify-content-center">
                                      <h3 style="color: #23499E;">Oops! Something went Wrong</h3>
                                    </div>
                                    <div class="d-flex justify-content-center text-center">
                                      <p>We encountered an error while submitting your survey.
                                      Please try again in a few moments.</p>
                                    </div>
                                  </div>
                                </div>
                                <div class="modal-footer d-flex justify-content-center">
                                  <button type="button" class="closeBtn" (click)="closeModalAlert('surveyErrorMsg')" data-bs-dismiss="modal">Close</button>
                                </div>
                              </div>
                            </div>
                          </div>

                          <script>
                            $(document).on("show", ".accordion", function (e) {
                            $(e.target).prev(".accordion-heading").addClass("accordion-opened");
                            });
                            $(document).on("hide", ".accordion", function (e) {
                            $(this)
                            .find(".accordion-heading")
                            .not($(e.target))
                            .removeClass("accordion-opened");
                            //$('.accordion-heading i').toggleClass('fa-chevron-right fa-chevron-down');
                            });

                            $(document).ready(function () {
                            $("#tile1sub").css("visibility", "hidden");
                            $("#tile1").mouseover(function () {
                            $("#tile1sub").css("visibility", "visible");
                            });
                            $("#tile1").mouseout(function () {
                            $("#tile1sub").css("visibility", "hidden");
                            });
                            });
                          </script>
